// @flow
import React from "react";
import { type FieldProps } from "redux-form";

type ValueProps = {|
  label: string,
|} & FieldProps;

function Value(props: ValueProps) {
  const { label, input } = props;

  return (
    <div className="field">
      <label>{label}</label>
      <p>{input.value}</p>
    </div>
  );
}

export default Value;
